import { useFeatureFlags } from '@eventbrite/feature-flag-utils';
import React, { useContext, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { logImpressionForSearch } from './requests';
import { useSearchRetrievalContext } from './RetrievalContextProviders';
interface EventTrackerProps {
    id: string | undefined;
    ad_id?: string;
    placement_id?: string;
    gaCategory: string | undefined;
    position?: number;
}

function isSearch(gaCategory: string | undefined) {
    return gaCategory === 'search';
}

const EventClickTrackerContext = React.createContext({
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    eventClickTracker: () => {},
});

export function useEventClickTracker() {
    const searchRetrievalContext = useContext(EventClickTrackerContext);

    return searchRetrievalContext;
}

export function EventTracker(props: EventTrackerProps) {
    const { retrievalContext, shouldUseSDK } = useSearchRetrievalContext();
    const { ref, inView } = useInView({
        triggerOnce: true,
        fallbackInView: true,
        // Do not create intersection observer if FF off
        skip: !shouldUseSDK,
    });
    const { useNewEventInteractionsTrackingSystem } = useFeatureFlags();

    useEffect(() => {
        if (!shouldUseSDK) return;
        if (!props.id) return;

        if (
            inView &&
            isSearch(props.gaCategory) &&
            !useNewEventInteractionsTrackingSystem
        ) {
            // Don't log if no position; isn't expected
            if (props.position) {
                logImpressionForSearch(
                    props.id,
                    props.position,
                    retrievalContext,
                    props.ad_id,
                    props.placement_id,
                );
            }
        }
    }, [
        inView,
        props.id,
        props.ad_id,
        props.placement_id,
        props.gaCategory,
        props.position,
        retrievalContext,
        shouldUseSDK,
        useNewEventInteractionsTrackingSystem,
    ]);

    if (!shouldUseSDK) return null;

    return <span ref={ref}></span>;
}
